import { useSession } from "providers/SessionProvider";
import { FeedUserProfileBase } from "views/knowledge/feed/FeedUserProfile/FeedUserProfileBase";

/**
 * Feed do Perfil do usuário logado.
 * @param props
 */
export const OwnProfile: React.FC = () => {
    const session = useSession();


    ////////////////////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////////////////////

    return (
        <FeedUserProfileBase userId={session.user.userId} breakpoint="md" />
    );
};
